import icon from './trending.png.js';
import template from './keyphrase_trend_widget_view.html';
import templateMaxView from './keyphrase_trend_widget_max.html';
import templateReportView from './keyphrase_trend_widget_report.html';

angular
    .module('MW.InsDashboard.BubbleD3',[
        'CoreColorService',
        'MW.Dashboard.DashboardWidgetService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.AppChromeService',
        'MW.Configuration',
        'MW.DashboardLegacy.Constants'
    ])
    .directive('bubbleD3',[
        'CoreColorService',
        'trendingThemesWidgetLabelService',
        '$routeParams',
        'analyzeFeatureToggleService',
    function(CoreColorService, trendingThemesWidgetLabelService, $routeParams, analyzeFeatureToggleService) {
    'use strict';

    return {
        template: '<div></div>',
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            chartData: '=data',
            drill: '&drill',
            isMaximized: '=maximized',
            chartType: '=',
            isReport: '=?',
            exportType: '=?',
            selected: '=?'
        },

        controller: ['$scope',function(scope) {

            scope.initState = function(){
                scope.height = 0;
                scope.width = 0;
                scope.isMaximized = false;
                scope.element = null;
                scope.svg = null;
                scope.min = 0;
                scope.max = 0;

                //Bubble Chart settings
                scope.volumeFontSize = 9;
                scope.collisionPadding = 10;
                scope.minCollisionRadius = 5;
                scope.maxLabelLineLengthMaximized = 15;
                scope.maxLabelLineLengthWidget = 10;
                scope.fGravity = -0.01;
                scope.fFriction = 0.1;
                scope.minKeyFontSize = 10;
                scope.maxKeyFontSize = 25;

                scope.fontSizeMaxView = 12;
                scope.fontSizeDashboardView = 10;

                //Bubble Chart properties initialized on creation
                scope.maxBubblesInDashboard = 0;
                scope.maxRadius = 0;
                scope.minxRadius = 0;
                scope.maxLabelLineLength = 0;

                scope.bubble = d3.layout.pack();
                scope.force = d3.layout.force();
                scope.keyFontScale = false;
                scope.rScale = function() { return false; };
            };

            scope.createVisualization = function (vType, data, element, isMaximized, clickOnWordFunc) {
                scope.initState();
                scope.element = element;
                scope.isMaximized = isMaximized;
                scope.click = clickOnWordFunc;
                scope.height = 223;
                scope.width = scope.element[0].clientWidth || scope.element[0].parentNode.clientWidth || 700;//IMPORTANT: Setting to 700 by default is needed for reports to render correctly in wkhtmltopdf.
                
                if (data.children) {
                    const sortedChildrenData = data.children.sort((a, b) => b.value - a.value);
                    data.children = sortedChildrenData;
                }        
                
                scope.max = Math.max.apply(Math,data.children.map(function(o){ return o.value; }));
                scope.min = Math.min.apply(Math,data.children.map(function(o){ return o.value; }));

                if (scope.isMaximized) {
                    scope.height = 400;
                }
                if(scope.isReport && typeof scope.isReport !== 'function') {
                    //IMPORTANT: Setting to 700 by default is needed for reports to render correctly in wkhtmltopdf.
                    scope.width = 700;
                    if(scope.exportType === 'widgetImage') {
                        scope.width = 1150;
                    }
                }
                scope.data = data;
                //Set the filter on the data to only show the top 7 words on the dashboard view
                //currently the max view is being handled on the backend call. We may want to consider updating scope
                //here in the future so we have more control for different views and have it evaluated based on view but,
                //currently it is not required.
                var dataFilter = {
                    maxWords: {
                        userView: 7
                    }
                };

                if (vType === 'cloud') {
                    scope.createWordCloud(data, dataFilter);
                }
                else //(vType=="bubble") //if something other than cloud or bubble is passed just do bubble
                {
                    if (scope.svg === null || !data.isUpdate) {
                        scope.initBubbleCloud(data, dataFilter);
                    }
                    scope.createBubbleCloud(data);
                }
            };

            scope.createWordCloud = function (data, dataFilter) {
                var MAX_VIEW_MIN_FONT_SIZE = 18;
                var MAX_VIEW_MAX_FONT_SIZE = 50;
                var MIN_VIEW_MIN_FONT_SIZE = 18;
                var MIN_VIEW_MAX_FONT_SIZE = 38;
                var maxWords = 20;
                var sizeFactor = 1;
                var gTransform = '';

                var wordScale;

                if (scope.selected && scope.selected.length === 0 && $routeParams.associatedThemes) {
                    scope.selected = $routeParams.associatedThemes.split(',');
                }


                var selectedAssociatedThemes = typeof scope.selected === 'string' ? scope.selected.split(',') : scope.selected.slice();
                for(var index = 0; index < selectedAssociatedThemes.length; index++) {
                    selectedAssociatedThemes[index] = selectedAssociatedThemes[index].replace(/%252C/g, ',').replace(/%2C/g, ',');
                }

                data.children = data.children.filter(function(node) {
                    if (selectedAssociatedThemes.indexOf(node.keyphrase) === -1) {
                        return node;
                    }
                });

                if (scope.selected.length === 0) {
                    scope.selectedNodes = [];
                }
                else {
                    scope.selected = [];
                }

                if (scope.isMaximized) {
                    wordScale = d3.scale.linear().domain([scope.min, scope.max]).range([MAX_VIEW_MIN_FONT_SIZE, MAX_VIEW_MAX_FONT_SIZE]);
                    sizeFactor = 1;
                    gTransform = 'translate(' + scope.width / 2 + ',' + scope.height / 2 + ')';
                }
                else {
                    sizeFactor = 2;
                    scope.height = scope.element[0].parentNode.clientHeight || scope.element[0].parentNode.parentNode.clientHeight; // Safety check, since sometimes it seems the parentNode also has a height of 0
                    scope.width = scope.element[0].parentNode.clientWidth;
                    maxWords = dataFilter.maxWords.userView + (Math.floor(scope.width / 150));
                    wordScale = d3.scale.linear().domain([scope.min, scope.max]).range([MIN_VIEW_MIN_FONT_SIZE * sizeFactor, MIN_VIEW_MAX_FONT_SIZE * sizeFactor]);
                    gTransform = 'scale('+ (1/sizeFactor) +')translate(' + scope.width + ',' + scope.height + ')';
                }

                // Safety check to avoid divide by zero error
                if (scope.height === 0) {
                    // Do the safety dance
                    var safeHeight = scope.element[0].parentNode.parentNode.clientHeight;
                    scope.height = safeHeight ? safeHeight : 223;
                }

                var datamax = d3.max(data.children, function (d) {
                    var val = Math.log(d.value || 1);
                    return val;
                });

                var datamin = d3.min(data.children, function (d) {
                    var val = Math.log(d.value || 1);
                    return val;
                });

                var heatmap = d3.scale.linear()
                    .domain([~~datamin, ~~datamax])
                    .interpolate(d3.interpolateRgb)
                    .range([CoreColorService.colors.blueSky, CoreColorService.colors.greenLime]);

                function draw(words) {
                    d3.select(scope.element[0]).selectAll('svg').remove();//when toggling back and forth between chart types remove the old one

                    var viz = d3.select(scope.element[0])
                        .append('svg')
                        .attr('width', scope.width * sizeFactor)
                        .attr('height', scope.height * sizeFactor);

                    viz.append('g')
                        .attr('transform', gTransform)
                        .selectAll('text')
                        .data(words)
                        .enter().append('text')
                        .style('font-size', function (d) {
                            return d.size + 'px';
                        })
                        .style('fill', scope.chartData.inputColor || CoreColorService.colors.blueMalibu)
                        .style('opacity', 0.75)
                        .style('cursor', 'pointer')
                        .on('click', scope.click)
                        .attr('text-anchor', 'middle')
                        .attr('data-classname', function (d) {
                            return d.keyphrase;
                        })
                        .attr('transform', function (d) {
                            return 'translate(' + [d.x, d.y] + ')rotate(' + d.rotate + ')';
                        })
                        .text(function (d) {
                            return d.text;
                        })
                        .append('svg:title')
                        .text(function (d) {
                            return d.keyphrase + ' ' + trendingThemesWidgetLabelService.formatNumber(d.value);
                        });

                }

                d3.layout.cloud().size([scope.width * sizeFactor, scope.height * sizeFactor])
                    .words(data.children)
                    .rotate(function () {
                        return 0;
                    })
                    .text(function (d) {
                        return d.keyphrase;
                    })
                    .fontSize(function (d) {
                        return wordScale(d.value);
                    })
                    .padding(10)
                    .on('end', draw)
                    .start(maxWords);
            };

            //Functions supporting bubble chart
            scope.gravity = function gravity(alpha) {
                var ax, ay, cx, cy;
                cx = scope.width / 2;
                cy = scope.height / 2;
                ax = alpha / 2;
                ay = alpha;
                return function (d) {
                    d.x += (cx - d.x) * ax;
                    return d.y += (cy - d.y) * ay * 3;
                };
            };

            scope.collide = function collide() {
                return function (d) {
                    return scope.node.each(function (d2) {
                        var distance, minDistance, moveX, moveY, x, y;
                        if (d !== d2) {
                            x = d.x - d2.x;
                            y = d.y - d2.y;
                            distance = Math.sqrt(x * x + y * y);
                            var dforceR = Math.max(scope.minCollisionRadius, scope.rScale(d.value));
                            var d2forceR = Math.max(scope.minCollisionRadius, scope.rScale(d2.value));
                            minDistance = dforceR + d2forceR + scope.collisionPadding; //+ d.out/2 + d2.out/2;
                            if (distance < minDistance) {
                                distance = (distance - minDistance) / distance * 0.4;
                                moveX = x * distance;
                                moveY = y * distance/scope.horizontalSpacingFactor;
                                d.x -= moveX;
                                d.y -= moveY;
                                d2.x += moveX;
                                return d2.y += moveY;
                            }
                        }
                    });
                };
            };

            scope.tick = function tick(e) {
                scope.node.each(scope.gravity(e.alpha * 0.1))
                    .each(scope.collide())
                    .attr('transform', function (d) {
                        return 'translate(' + Math.max(d.r*1.7 , Math.min(scope.width - d.r*1.7, d.x)) + ',' + Math.max(d.r*1.7 , Math.min(scope.height - d.r*1.7, d.y)) + ')';
                    });
            };

            scope.initBubbleCloud = function(data,dataFilter){
                if(!scope.isMaximized){
                    scope.height = parseInt(scope.element[0].parentNode.clientHeight || scope.element[0].parentNode.parentNode.clientHeight || $(window).height());
                    scope.width = parseInt(scope.element[0].parentNode.clientWidth || $(window).width());
                }

                scope.horizontalSpacingFactor=1;
                if(scope.width>870) {
                    scope.horizontalSpacingFactor=3;
                    scope.collisionPadding = 20;
                }
                else if(scope.width>750) {
                    scope.horizontalSpacingFactor=2.2;
                    scope.collisionPadding = 20;
                }

                scope.maxBubblesInDashboard      = dataFilter.maxWords.userView + (Math.floor(scope.width/150));
                scope.maxRadius                  = scope.isMaximized ? 50 : 35;
                scope.minxRadius                 = scope.isMaximized ? 25 : 20;
                scope.maxLabelLineLength          = scope.isMaximized ? scope.maxLabelLineLengthMaximized : scope.maxLabelLineLengthWidget;

                scope.keyFontScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minKeyFontSize, scope.maxKeyFontSize]);
                scope.rScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minxRadius, scope.maxRadius]);

                // scope next loop goes through all of the various words, and calculates the diameter of the circle with the rScale function.
                // It then turns scope into the area of a square, and adds it to a running total.
                var combinedArea = 0;

                angular.forEach(data.children, function forEachData(point) {
                    var scopeDiameter = 2*scope.rScale(point.value),
                        scopeArea = scopeDiameter*scopeDiameter;
                    combinedArea += scopeArea;
                });

                var availableArea = scope.width * scope.height;
                // Next, if the combined area of the squares is larger than the area of the rectangle we're fitting the circles into
                if (combinedArea > availableArea) {
                    // Scale the radius of the points down by some factor based off the width of the circles.
                    // Note: scope scaling factor is a little arbitrary, and may be tweakable. It seems to work alright if all 9 values in a small content stream are the same.
                    var scalingOffset = availableArea/combinedArea;
                    scope.rScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minxRadius, scope.maxRadius*scalingOffset]);
                    scope.keyFontScale = d3.scale.linear().domain([scope.min, scope.max]).range([scope.minKeyFontSize, scope.maxKeyFontSize*scalingOffset]);
                }

                scope.bubble = d3.layout.pack()
                    .sort(function(a, b) { return d3.descending(a.value, b.value); })
                    .size([scope.width, scope.height])
                    .padding(10)
                    .value(function(d) { return (d.value); });

                scope.force = d3.layout.force()
                    .gravity(scope.fGravity)
                    .friction(scope.fFriction)
                    .charge(function (d) {
                        return Math.pow(d.r, 2.0) / 8;
                    })
                    .size([scope.width, scope.height])
                    .on('tick', scope.tick);

                d3.select(scope.element[0]).selectAll('svg').remove();

                scope.svg = d3.select(scope.element[0])
                    .append('svg')
                    .attr('width', scope.width)
                    .attr('height', scope.height)
                    .attr('class', 'bubble')
                    .attr('viewBox', '0 0 ' + scope.width + ' ' + scope.height )
                    .attr('preserveAspectRatio', 'xMidYMid slice');
            };

            scope.createBubbleCloud = function(data){
                if (scope.selected && scope.selected.length === 0 && $routeParams.associatedThemes) {
                    scope.selected = $routeParams.associatedThemes.split(',');
                }

                var selectedAssociatedThemes = typeof scope.selected === 'string' ? scope.selected.split(',') : scope.selected.slice();
                for(var index = 0; index < selectedAssociatedThemes.length; index++) {
                    selectedAssociatedThemes[index] = selectedAssociatedThemes[index].replace(/%252C/g, ',').replace(/%2C/g, ',');
                }

                data.children = data.children.filter(function(node) {
                    if (selectedAssociatedThemes.indexOf(node.keyphrase) === -1) {
                        return node;
                    }
                });

                if (scope.selected.length === 0) {
                    scope.selectedNodes = [];
                }
                else {
                    scope.selected = [];
                }

                data.name = 'keyphrases';
                for(var i = 0; i < data.children.length; i++){
                    data.children[i].name = data.children[i].keyphrase;
                }
                scope.force.nodes(data.children).start();

                scope.node = scope.svg.selectAll('.node')
                    .data(scope.bubble.nodes(data)
                        .filter(function (d) { return !d.children;})
                        .filter(function(d,i) {
                            if (!scope.isMaximized) {
                                return i < scope.maxBubblesInDashboard;
                            }
                            else
                            {
                                return i < 12;
                            }
                        }));

                var nodeGroup = scope.node
                    .enter().append('g')
                    .attr('class', 'node')
                    .transition(1000);

                scope.node.exit().remove();
                scope.node
                    .append('circle')
                    .style('fill', function(d) {
                        if(scope.selected && scope.selected.indexOf(d.keyphrase) > -1)
                            return CoreColorService.colors.white;

                        return scope.chartData.inputColor || CoreColorService.colors.blueMalibu;
                    })
                    .attr("stroke", scope.chartData.inputColor || CoreColorService.colors.blueMalibu)
                    .attr("stroke-width", function(d) {
                        if(scope.selected && scope.selected.indexOf(d.keyphrase) > -1)
                            return 1;
                        return 0;
                    })
                    .style('cursor', 'pointer')
                    .attr('class', 'circle')
                    .attr('data-classname', function (d) { return d.keyphrase; })
                    .attr('data-value', function (d) { return scope.rScale(d.value); })
                    .on('click', scope.click)
                    .transition().duration(2000)
                    .attr('r', function(d) {
                        var r = scope.rScale(d.value);
                        this.parentNode.setAttribute('d', r*2);
                        return r; });

                scope.node
                    .append('text')
                    .attr('text-anchor', 'middle')
                    .attr('class', 'label')
                    .attr('font-size', function (d) {
                        return (scope.isMaximized) ? scope.fontSizeMaxView : scope.fontSizeDashboardView;
                    })
                    .attr('h', function (d) { return 0;})
                    .on('click', scope.click)
                    .style('font-weight', '400')
                    .style('fill', CoreColorService.colors.black)
                    .style('cursor', 'pointer')
                    .attr('data-classname', function (d) { return d.keyphrase; });

                var label = scope.svg.selectAll('.label');
                if(data.isUpdate){
                    label.selectAll('tspan').remove();
                }

                label.each(function(d) {
                    var words = d.keyphrase.split(' '),
                        wordNum = words.length,
                        j=0, line = [];

                    line[0] = words[0];

                    for (var i=1 ; i < wordNum; i++ ){
                        if ((line[j].length + 1 + words[i].length) > scope.maxLabelLineLength) {
                            j++;
                            line.push(words[i]);
                        }
                        else {line[j] = line[j] + ' ' + words[i];}
                    }

                    for (i=0 ; i <= j; i++ ){
                        d3.select(this).append('tspan')
                            .attr('font-size', function (d) {
                                var fontSize =  (scope.isMaximized) ? scope.fontSizeMaxView : scope.fontSizeDashboardView;
                                var height = this.parentNode.getAttribute('h');
                                this.parentNode.setAttribute('h', + height + fontSize );
                                return fontSize;
                            })
                            .text(function (d) { return line[i]; })
                            .attr('x', function (d) { return 0; })
                            .attr('dy', function(d) {
                                if(i == 0 && j == 0) {
                                    return 0.4 * -0.5 + 'em';
                                } else {
                                    if(i == 0) {
                                        return j * -1.5 * (0.5) + 'em';
                                    } else {
                                        return '1.2em';
                                    }
                                }

                            });
                    }
                });

                label
                    .append('tspan')
                    .text(function (d) {
                        return trendingThemesWidgetLabelService.formatNumber(d.value);
                    })
                    .attr('font-size', function (d) {
                        return (scope.isMaximized) ? 12 : 9;})
                    .attr('class', 'volume')
                    .attr('x', function (d) { return 0; })
                    .attr('dy', '1.4em')
                    .style('font-weight', '400')
                    .style('fill', CoreColorService.colors.black);
            };
        }],
        link: function (scope, element) {
            scope.selectedNodes = scope.selected || [];
            function clickOnWordFunc(node) {
                if (!scope.isMaximized)
                    return;

                if(scope.selectedNodes.indexOf(node.keyphrase) === -1) {
                    d3.select(this.parentNode).select('circle')
                        .style('fill', CoreColorService.colors.white)
                        .attr("stroke-width", 1);
                    scope.selectedNodes.push($(this).attr('data-classname'));
                } else {
                    d3.select(this.parentNode).select('circle')
                        .style('fill', scope.chartData.inputColor || CoreColorService.colors.blueMalibu)
                        .attr("stroke-width", 0);
                    scope.selectedNodes.splice(scope.selectedNodes.indexOf($(this).attr('data-classname')), 1);
                }

                if ($routeParams["associatedThemes"] && scope.selectedNodes.length > 0) {
                    var associatedThemes = $routeParams["associatedThemes"].split(',');

                    if (associatedThemes.indexOf(node.keyphrase) === -1) {
                        associatedThemes.push(node.keyphrase.replace(/,/g, '%252C'));
                    }

                    scope.selectedNodes = associatedThemes;
                }
                scope.drill({id:scope.selectedNodes});
            }

            scope.$on('widgetResized', function(){
                if(!scope.data) {return;}
                scope.createVisualization(scope.chartType,scope.data,element,scope.isMaximized,clickOnWordFunc);

            });
            scope.$watch(function() { return scope.chartData;}, function(data) {

                if(!data) {return;}
                scope.createVisualization(scope.chartType,data,element,scope.isMaximized,clickOnWordFunc);
            });

        }
    };
}]);

angular
    .module('MW.InsDashboard.KeyphraseTrendWidget',[
        'MW.Dashboard.DashboardStateService',
        'MW.Dashboard.DashboardWidgetService',
        'MW.Framework.CoreCommon',
        'MW.Framework.TranslationService',
        'MW.InsDashboard.insightsBackendService',
        'DashboardChartConfigService',
        'MW.InsDashboard.InsWidgetConfigService',
        'MW.Framework.CoreBreadcrumb',
        'CoreColorService',
        'ContentService',
        'MW.Dashboard.Base64Service'])
    .directive('keyphraseTrendWidget',[
        'DashboardWidgetService',
        'CoreCommon',
        'translationService',
        'insightsBackendService',
        'DashboardChartConfigService',
        'InsWidgetConfigService',
        '$timeout',
        'DashboardStateService',
        '$location',
        '$routeParams',
        'Breadcrumb',
        'CoreColorService',
        'ContentService',
        'Base64Service',
        'colorPickerService',
        'trendingThemesWidgetLabelService',
        'analyzeFeatureToggleService',
    function(DashboardWidgetService, CoreCommon, translationService, insightsBackendService, DashboardChartConfigService, InsWidgetConfigService, $timeout, DashboardStateService, $location, $routeParams, Breadcrumb, CoreColorService, ContentService, Base64Service, colorPickerService, trendingThemesWidgetLabelService, analyzeFeatureToggleService){
    'use strict';

    var keyphraseTrendWidget = DashboardWidgetService.getWidget('keyphrase-trend-widget');

    var keyphraseTrendWidgetController = function($scope){
        $scope.tableSettings = {
            enabled: true,
            data: {},
            rowTitle: translationService.getLocalizedString('Themes'),
            summaryTitle: translationService.getLocalizedString('Total'),
            countField: 'count',
            percentField: 'percent',
            titleField: 'name'
        };
        $scope.showTable = false;

        var getDefaultChartTypeFromSettings = function getDefaultChartTypeFromSettings() {
            return CoreCommon.isUsable($scope.widget.settings.selectedGraphType)?$scope.widget.settings.selectedGraphType.id : $scope.widget.getDefaultChartType().id;
        };

        $scope.initSettings = function(){
            InsWidgetConfigService.readyWidgetData($scope);
        };
        $scope.toggleGraph = function toggleGraph(chartType) {
            $scope.documentParams.associatedThemes = [];
            $scope.documentRequest.associatedThemes = [];
            if(InsWidgetConfigService.queryRequestSettings.keyphrase){
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
            }
            var oldGraphType = $scope.graphType;
            $scope.graphType = chartType;
            //if (oldGraphType !== chartType) {
                $scope.showTable = false;
                $scope.resetBreadcrumb();
                $scope.fetchData();
                $scope.initSettings();
            //}
        };

        $scope.toggleTable = function toggleTable() {
            if(InsWidgetConfigService.queryRequestSettings.keyphrase){
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
            }
            $scope.graphType = 'table';
            $scope.resetBreadcrumb();
            $scope.fetchData();
        };

        if($scope.widget.hasRequiredSettings()){
            $scope.graphType = getDefaultChartTypeFromSettings();
        }
    };

    var keyphraseTrendWidgetLink = function(scope) {
        scope.widgetIsLoading = false;
        scope.notConfigured = false;
        scope.fetching = false;
        scope.serviceError = false;
        scope.noDataFromServer = false;
        scope.insightsService = 'volumeServices';
        scope.numKeyphrases= 20;
        scope.documentRequest = {};
        scope.noWidgetContent = false;
        scope.selectedNodes = [];

        /* Fetching words that were stemmed by putting them in this dictionary to take it for drill later on*/
        scope.chartDataDictionary = {};

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var oldParams, newParams, keyphrase, associatedThemes;
            if(newVal === oldVal) {
                return;
            }

            oldParams = getRequestParams(oldVal);
            newParams = getRequestParams(newVal);

            if(newParams.keyphrase) {
                newParams.keyphrase = decodeURIComponent(newParams.keyphrase);
                keyphrase = decodeURI((newParams.keyphrase || newParams.concept).replace(/(%20)/g, ' '));
                scope.selectedNodes = keyphrase.split(',');
                updateBreadcrumb(keyphrase);
            } else if (newParams.associatedThemes) {
                updateBreadcrumb(newParams.associatedThemes);
                newParams.associatedThemes = decodeURIComponent(newParams.associatedThemes);
                associatedThemes = decodeURI((newParams.associatedThemes || newParams.concept).replace(/(%20)/g, ' '));

                scope.selectedNodes = associatedThemes;
                scope.documentRequest.associatedThemes = associatedThemes.split(',');
            } else {
                scope.selected = [];
                scope.selectedNodes = [];
                scope.documentParams.associatedThemes = [];
                scope.documentRequest.associatedThemes = [];
                updateBreadcrumb();
            }

            scope.fetchData();

            if(oldParams.keyphrase !== undefined && newParams.keyphrase === undefined) {
                scope.documentRequest['keyphrase'] = null;
                scope.documentRequest['concept'] = null;
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
                InsWidgetConfigService.queryRequestSettings.concept = null;
                scope.$broadcast('contentStream_queryReset', InsWidgetConfigService.queryRequestSettings);
            } else if((newParams.keyphrase !== undefined && oldParams.keyphrase === undefined) || (newParams.keyphrase !== undefined && oldParams.keyphrase !== undefined && newParams.keyphrase !== oldParams.keyphrase)) {
                scope.documentRequest['keyphrase'] = keyphrase;
                InsWidgetConfigService.queryRequestSettings['keyphrase'] = keyphrase;
                scope.chartRequest['keyphrase'] = keyphrase;
            } else if (newParams.keyphrase === undefined && oldParams.keyphrase === undefined) {
                scope.documentRequest['keyphrase'] = null;
                scope.documentRequest['concept'] = null;
                InsWidgetConfigService.queryRequestSettings.keyphrase = null;
                InsWidgetConfigService.queryRequestSettings.concept = null;
            }

            //We watch for updateContentStreamQuery on widget_content_stream_maximized.
            if(scope.isMaximized) {
                scope.updateContentStreamQuery = {
                    name: scope.breadcrumbs && scope.breadcrumbs[scope.breadcrumbs.length - 1].name,
                    query: InsWidgetConfigService.queryRequestSettings
                };
            } else { //Use the old content stream.
                scope.$broadcast('contentStream_documentsLoad', InsWidgetConfigService.queryRequestSettings);
            }
        });

        var getRequestParams = function getRequestparams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        scope.drill = function drill(keyphrase) {
            var selectedKeyphrases = [];
            var selectedKeyPhrasesbreadcrumb = [];
            for (var i = 0, max = keyphrase.length; i < max; i++) {
                if(Object.keys(scope.chartDataDictionary).indexOf(keyphrase[i]) > -1)
                    selectedKeyphrases.push(scope.chartDataDictionary[keyphrase[i]].join());
            }

            if(scope.isMaximized) {
                var queryParams = {};
                if(keyphrase.length > 0) {
                    queryParams['drilled'] = true;
                    var encodedKeyphrase = keyphrase;

                    for (var i = 0; i < keyphrase.length; i++) {
                        encodedKeyphrase[i] = keyphrase[i].replace(/,/g, '%2C');
                    }

                    queryParams['associatedThemes'] = encodedKeyphrase.join();
                } else {
                    queryParams['associatedThemes'] = [];
                    queryParams['drilled'] = null;
                }

                updateLocationURL(queryParams);
                
                if(keyphrase.length > 0) {
                    scope.documentRequest.associatedThemes = keyphrase;
                } else {
                    delete scope.documentRequest.associatedThemes;
                }
            }

            if(scope.graphType !== 'table') {
                scope.$apply(function() {
                    if(keyphrase.length > 0) {
                        scope.documentRequest.keyphrase = selectedKeyphrases.join();
                    } else {
                       delete scope.documentRequest.keyphrase;
                    }
                    scope.$broadcast('contentStream_documentsLoad', scope.documentRequest);
                });
            } else {
                scope.$broadcast('contentStream_documentsLoad', scope.documentRequest);
            }
        };

        var updateLocationURL = function updateLocationURL(queryParams) {
            var selectedKeyphrases =  [];
            var keyphrase = queryParams.keyphrase || [];
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }
            for(var i = 0, max = keyphrase.length; i < max; i++) {
                if(Object.keys(scope.chartDataDictionary).indexOf(keyphrase[i]) > -1)
                    selectedKeyphrases.push(scope.chartDataDictionary[keyphrase[i]].join());
            }
            if(selectedKeyphrases.length > 0)
                urlQuery['keyphrase'] = selectedKeyphrases.join();

            $location.path(maxPath).search(urlQuery);
        };

        var updateBreadcrumb = function updateBreadcrumb(keyphrase) {
            var dashboardPath,
            widgetPath,
            widgetAssociatedThemesPath,
            selectionTitle = '',
            dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;

            selectionTitle += keyphrase && typeof keyphrase === "string" ? keyphrase : '';
            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));

            if(selectionTitle === '') {
               var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                   subCrumbs = [],
                   myNewPath,
                   subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, subCrumbs:subCrumbs}));
            } else {
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));

                var associatedThemes = keyphrase.split(',');

                var associatedThemesQueryString = '';

                for(var index = 0; index < associatedThemes.length; index++) {
                    if(index === 0) {
                        associatedThemesQueryString += associatedThemes[index];
                    } else {
                        associatedThemesQueryString += ',' + associatedThemes[index];
                    }
                    widgetAssociatedThemesPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false&associatedThemes='+associatedThemesQueryString;

                    var decodedAssociatedThemeName = decodeURIComponent(associatedThemes[index]).replace(/%252C/g, ',').replace(/%2C/g, ',');
                    scope.breadcrumbs.push(Breadcrumb.build({name:decodedAssociatedThemeName, link: widgetAssociatedThemesPath}));
                }
            }
        };

        var wasBreadcrumbReset = false;
        scope.resetBreadcrumb = function resetBreadcrumb() {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + scope.widget.id;
            }

            var urlQuery = {
                editMode:editMode
            };

            updateBreadcrumb();
            $location.path(maxPath).search(urlQuery);
            wasBreadcrumbReset = true;
        };

        // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
        scope.$on('widgetFiltersUpdated', function() { scope.fetchData(true); });

        scope.fetchData = function() {
            function processTable(data) {
                var datapoints = data.datapoints,
                    totalDatapoints = data.totalDatapoints,
                    totalVolume = 0,
                    tableData = [];

                var searchName = (typeof scope.searches == 'undefined' || scope.searches.length == 0) ? scope.inputs[0].name : scope.searches[0].name;

                for(var i = 0; i < totalDatapoints; i++) {
                    tableData[i] = {
                        label: datapoints[i].keyphrase
                    };

                    tableData[i].data = [{
                        name: searchName,
                        count: trendingThemesWidgetLabelService.formatNumber(datapoints[i].volume),
                        filterField: datapoints[i].keyphrase
                    }];

                    totalVolume += datapoints[i].volume;
                }

                scope.tableSettings.data = tableData;
                scope.tableSettings.summary = [totalVolume];
                scope.tableSettings.displayField = 'count';
                scope.tableSettings.sortOnField = searchName;

                scope.tableSettings.drilldown = function drilldown(datapoint) {
                    scope.drill([datapoint.filterField]);
                };

                scope.tableSettings.tooltip = function tooltip(datapoint) {
                    return translationService.getLocalizedString('Trending theme') + ': ' + datapoint.count;
                };
            }

            /*
            * Content filter in Trending theme and Topic Momentum widgets
            * Transform to the format which is accepted by Content Filter
            */
            var transformDatapointsToOptions = function transformDatapointsToOptions(datapoints){
                var options = [];
                var bubbleMax = 12;
                var max = datapoints.length;

                if (scope.graphType === 'bubble' && datapoints.length > bubbleMax){
                    max = bubbleMax;
                }

                for(var i=0; i < max; i++) {
                    var o = {};
                    o['val'] = datapoints[i]['keyphrase'];
                    o['name'] = datapoints[i]['keyphrase'];
                    options.push(o);
                }
                return options;
            };

            function loadData(isUpdate){
                scope.chartDataDictionary = {};

                scope.documentParams.associatedThemes = scope.documentRequest.associatedThemes;
                if (scope.documentParams.associatedThemes) {
                    scope.documentParams.size += scope.documentParams.associatedThemes.length;

                    for (var i = 0; i < scope.documentParams.associatedThemes.length; i++) {
                        scope.documentParams.associatedThemes[i] = scope.documentParams.associatedThemes[i].replace(/%252C/g, '%2C');
                    }
                }

                insightsBackendService.consolidatedService.query(scope.documentParams, function(result){
                    var serverData = result.data[0][scope.currentInputId],
                        datapoints = serverData.datapoints,
                        totalDocuments = serverData.totalDocuments;
                    /*
                    * Content filter in Trending theme and Topic Momentum widgets
                    * Here we update the data for the content filter,
                    * so the content filter won't need to mak a seperate call to consolidated.
                    */
                    ContentService.setOptions(transformDatapointsToOptions(datapoints));
                    if (typeof scope.widget.settings.filteredContent  !== 'undefined') {
                        var filtered_data = [];
                        for ( var i = 0, max = datapoints.length; i < max ; i++) {
                            if ( scope.widget.settings.filteredContent.indexOf(datapoints[i].keyphrase) === -1) {
                                filtered_data.push(datapoints[i]);
                            }
                        }
                        datapoints = filtered_data;
                    }

                    var datapointsLength = typeof datapoints !== 'undefined' ? datapoints.length : 0,
                        totalDocumentsLength = typeof totalDocuments !== 'undefined' ? totalDocuments : 0;

                    if (datapointsLength === 0 && totalDocumentsLength === 0) {
                        scope.noContent = true;
                        scope.noWidgetContent = false;
                    } else if (datapointsLength === 0 && totalDocumentsLength !== 0) {
                        scope.noContent = false;
                        scope.noWidgetContent = true;
                    } else {
                        scope.noDataFromServer = false;
                    }

                    var chartData = {children:[]};
                    for(var i = 0, max = datapointsLength; i < max; i += 1 ) {
                        chartData.children.push({'keyphrase':datapoints[i].keyphrase,'value':datapoints[i].volume});
                        scope.chartDataDictionary[datapoints[i].keyphrase] = datapoints[i].related_keyphrases;
                    }

                    chartData.isUpdate = isUpdate;
                    scope.chartData=chartData;

                    // provide color selection from its inputs/searchIds object
                    var defaultColors = CoreColorService.getColors('default');
                    scope.chartData.inputColor = defaultColors[8]; // blueMalibu

                    if(scope.widget.settings.searchIds && scope.widget.settings.searchIds.length === 1) {
                        var encodedInputId = Base64Service.encode(scope.widget.settings.searchIds[0].searchId);

                        if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                            scope.chartData.inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
                        } else {
                            scope.chartData.inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
                        }
                    } else if(scope.widget.settings.inputs && scope.widget.settings.inputs.length === 1) {
                        var encodedInputId = Base64Service.encode(scope.widget.settings.inputs[0].id);

                        if(typeof DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] === 'undefined') {
                            scope.chartData.inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId] = defaultColors[DashboardStateService.inputIdsToColorMapping.colorIndex++];
                        } else {
                            scope.chartData.inputColor = DashboardStateService.inputIdsToColorMapping.colors[encodedInputId];
                        }
                    }

                    if (scope.graphType && scope.graphType === 'bubble') {
                        scope.chartData.inputColor = colorPickerService.lightenColorIfNecessary(scope.chartData.inputColor);
                    }

                    scope.widgetIsLoading=false;

                    if(serverData.complete !== 'undefined' && serverData.complete === false){
                        scope.chartDataObject.pendingData = true;
                        $timeout(function(){
                            loadData(true);
                        },5000);
                    } else {
                        scope.chartDataObject.pendingData = false;
                    }
                },
                function(){ scope.serviceError=true; scope.widgetIsLoading=false; });
            }

            scope.initSettings();

            if(!scope.readyToQuery) {return;}

            scope.widgetIsLoading = true;
            scope.serviceError = false;
            scope.noDataFromServer = false;
            scope.notConfigured = false;
            scope.currentInputId = '';

            var baseParams = {
                insObject: 'keyphraseHistograms',
                size: scope.numKeyphrases,
                stemming: true
            };

            if(scope.inputs){
                switch (scope.inputs[0].inputType) {
                    case 'rss':
                        baseParams.rssFeeds = [scope.inputs[0].id];
                        scope.currentInputId = scope.inputs[0].id;
                        break;
                    case 'tags':
                        baseParams.tags = [scope.inputs[0].name];
                        scope.currentInputId = scope.inputs[0].name;
                        break;
                    default:
                        baseParams.agents = [scope.inputs[0].id];
                        scope.currentInputId = scope.inputs[0].id;
                        break;
                }

            } else if(scope.searches) {
                scope.currentInputId = scope.searches[0].agent;
                baseParams.agents = [scope.searches[0].agent];
            }

            scope.documentParams = angular.extend(baseParams,scope.chartRequest);

            scope.chartDataObject.insObject = scope.insightsService;

            if(scope.graphType === 'table') {
                insightsBackendService.consolidatedService.query(scope.documentParams , function(data){

                        var serverData = data.data[0][scope.currentInputId],
                            datapoints = serverData.datapoints;

                        /*
                        * Content filter in Trending theme and Topic Momentum widgets
                        * Here we update the data for the content filter,
                        * so the content filter won't need to mak a seperate call to consolidated.
                        */
                        ContentService.setOptions(transformDatapointsToOptions(datapoints));
                        if (typeof scope.widget.settings.filteredContent  !== 'undefined') {
                            var filtered_data = [];
                            for ( var i = 0, max = datapoints.length; i < max ; i++) {
                                if ( scope.widget.settings.filteredContent.indexOf(datapoints[i].keyphrase) === -1) {
                                    filtered_data.push(datapoints[i]);
                                }
                            }
                            serverData.datapoints = filtered_data;
                            serverData.totalDatapoints = filtered_data.length;
                        }

                        processTable(serverData);

                    }, function(){
                        scope.widgetIsLoading=false;
                        scope.serviceError=true;
                    }
                );
                scope.widgetIsLoading = false;
                scope.showTable = true;
            } else {
                checkRoutes();
                loadData(false);
            }
        };

        var checkRoutes = function checkRoutes() {
            if($routeParams.keyphrase && !wasBreadcrumbReset) {
                if (typeof $routeParams.keyphrase === 'string') {
                    scope.selectedNodes = $routeParams.keyphrase.split(',');
                    updateBreadcrumb($routeParams.keyphrase);
                } else {
                    scope.selectedNodes = [];
                    updateBreadcrumb();
                }
            }
        };

        if($routeParams.associatedThemes) {
            updateBreadcrumb($routeParams.associatedThemes);
        }

        if(scope.widget.hasRequiredSettings()){
            scope.fetchData();
        }
        else {scope.notConfigured=true;}
    };

    return new WidgetDirective(keyphraseTrendWidget, keyphraseTrendWidgetLink, keyphraseTrendWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService,CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    'use strict';

    DashboardWidgetService.register({
        name: translationService.getLocalizedString('Trending Themes'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('The Trending Themes widget gives insight into keywords and ' +
            'key phrases that are most frequently associated with a brand, ' +
            'product, event or topic. The widget is useful for discovering ' +
            'potential emerging trends. It can also be used to identify ' +
            'keywords that you may want to add or remove from the search. ' +
            'The widget works best using one input.'),
        directive:'keyphrase-trend-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'source': [],
            'maxAgents': 1
        },
        displayOrder: 8,
        allowExport: true,
        requiredSettings: ['dateRange'],
        availableSettings: ['dateRange','title','news','social','broadcast','rss','tags','chartType', 'filteredContent'],
        availableFilters: [
            {
                name:'Content',
                id:'content'
            },
            {
                name: 'Country',
                id: 'country'
            }, {
                name: 'Language',
                id: 'language'
            }, {
                name: 'Sentiment',
                id: 'sentiment'
            }],
        availableChartTypes:[{name:'Word Cloud',id:'cloud'}, {name:'Bubble',id:'bubble'}],
        getDefaultChartType: function() {
            return this.availableChartTypes[1];
        },
        hasRequiredSettings: function(){
            var _widget = this;
            return InsWidgetConfigService.hasSelectedAnInput(_widget);
        },
        template,
        templateMaxView,
        templateReportView
    });
}]);
